import React, { useState } from 'react';
import swal from 'sweetalert';

import WithdrawalsApi from '../../../Api/CRM/Modules/WithdrawalsApi';
import GetWithdrawalDetailsResponse from '../../../Api/CRM/Responses/WithdrawalDetailsResponse';
import ButtonAccept from '../../elements/ButtonAccept';
import ButtonDecline from '../../elements/ButtonDecline';
import Card from '../../elements/common/Card';
import ColoredStatus from '../../elements/common/ColoredStatus';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import { PERMISSION } from '../../helpers/Permissions';
import { handleResponseError } from '../../helpers/ResponseErrorHelper';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import UserActivity from '../user/UserActivity';

import WithdrawalDetails from './WithdrawalDetails';

function WithdrawalShow() {
    const { id } = useNumberParams();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [withdrawal, setWithdrawal] = useState<GetWithdrawalDetailsResponse>({} as GetWithdrawalDetailsResponse);
    const updateWithdrawal = () => WithdrawalsApi.getWithdrawalDetails(id).then(setWithdrawal);

    function confirmAction(name: 'accept' | 'decline', action: () => Promise<unknown>) {
        swal({
            title: `${name.charAt(0).toUpperCase()}${name.slice(1)} withdrawal`,
            text: `Are you sure you want to ${name} this withdrawal?`,
            icon: 'warning',
            buttons: ['Cancel', 'OK'],
            dangerMode: true,
        }).then((confirmed) => {
            if (confirmed) {
                setIsLoading(true);
                action()
                    .then(updateWithdrawal)
                    .catch(handleResponseError)
                    .finally(() => setIsLoading(false));
            }
        });
    }

    useOnce(updateWithdrawal);

    const withdrawalLogs = withdrawal.withdrawal_logs?.map((log) => (
        <TableDetailsBody key={log.id}>
            <Row label="Type">
                <ColoredStatus status={log.type} />
            </Row>
            <Row label="Message">{log.message}</Row>
            <Row label="Data">
                <code>{log.data}</code>
            </Row>
        </TableDetailsBody>
    ));

    return (
        <>
            <WithdrawalDetails withdrawal={withdrawal} />
            {withdrawalLogs?.length ? <Card title="Withdrawal log">{withdrawalLogs}</Card> : null}
            {withdrawal.user_id ? <UserActivity userId={withdrawal.user_id} /> : null}
            {withdrawal.status === 'pending' && (
                <>
                    <ButtonAccept
                        disabled={isLoading}
                        action={() => confirmAction('accept', () => WithdrawalsApi.acceptById(id))}
                        permissions={[PERMISSION.UPDATE_WITHDRAWAL]}
                    />
                    <ButtonDecline
                        disabled={isLoading}
                        action={() => confirmAction('decline', () => WithdrawalsApi.declineById(id))}
                        permissions={[PERMISSION.UPDATE_WITHDRAWAL]}
                    />
                </>
            )}
        </>
    );
}

export default WithdrawalShow;
